import { createFileRoute, redirect, } from '@tanstack/react-router';
import { ensureDefined, } from '@tymia/shared';
import { pick, } from 'remeda';
import { api, } from '../../../../../api/Api.js';
import { setPostLoginRedirect, } from '../../../../../auth/PostLoginRedirect.js';
export const Route = createFileRoute('/client/account/invoice')({
    validateSearch(search) {
        if (search.id && search.type) {
            return pick(search, ['id', 'type']);
        }
        return {};
    },
    loaderDeps: ({ search }) => search,
    shouldReload: false,
    async loader({ location, deps: search }) {
        const result = await api.client.account.invoice.search.request({
            checkId: search.id,
            checkType: search.type,
        });
        if (result.status === 'error') {
            if (result.reason === 'unauthorized') {
                setPostLoginRedirect({
                    type: 'internal',
                    href: location.href,
                });
                throw redirect({
                    to: '/login',
                });
            }
            if (result.reason === 'onboarding required') {
                setPostLoginRedirect({
                    type: 'internal',
                    href: location.href,
                });
                throw redirect({
                    to: '/client/register',
                    search: {
                        id: ensureDefined(search.id),
                        type: ensureDefined(search.type),
                    },
                });
            }
        }
        return result;
    },
});
//# sourceMappingURL=ClientAccountInvoiceRoute.js.map